<mat-card appearance="outlined">
  <div class="section-title">
    {{ title }}
  </div>

  <div class="section-description">
    {{ description }}
  </div>

  <mat-chip-listbox *ngIf="partnerList?.length">
    <mat-chip-option
      *ngFor="let partner of partnerList"
      (removed)="removePartner(partner)"
      [removable]="isDataEditable"
      [matTooltip]="{
        partnerName:partner?.name,
        partnerId:partner?.id,
        partnerExtIds:partner?.extIds,
      } | partnerDetails"
      matTooltipClass="tooltip-html"
    >
      {{ partner.name }}
      <ui-svg-icon [name]="iconNameList.Close" [width]="18" matChipRemove></ui-svg-icon>
    </mat-chip-option>
  </mat-chip-listbox>
  <div *ngIf="isDataEditable" class="tw-mt-8 link" (click)="managePartners()">
    <ui-svg-icon class="tw-align-middle" [name]="iconNameList.Add"></ui-svg-icon>
    <span class="tw-align-middle"> {{ 'containerComponents.partnerSelection.addPartners' | translate }}</span>
  </div>
</mat-card>
